export const truncateText = (productFullName: string, stringLenght: number) => {
    return productFullName.length > stringLenght
        ? productFullName.slice(0, stringLenght) + '...' 
        : productFullName;
}
